export const editFormStatus = (status, form) => {
	form.classList.add( status );
	form.classList.remove( `sending` );
	form.classList.add( `sent` );
};
